export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string; allowedRoles?: string[] }
  children?: INavigationRoute[]
}

const filterRoutesByRole = (routes: INavigationRoute[], role: string): INavigationRoute[] => {
  return routes
    .filter((route) => {
      if (route.meta.allowedRoles && route.meta.allowedRoles.includes(role)) {
        return true
      }
      if (!route.meta.allowedRoles) {
        return true
      }
      return false
    })
    .map((route) => {
      if (route.children) {
        route.children = filterRoutesByRole(route.children, role)
      }
      return route
    })
}

const sidebarRoutes = {
  root: {
    name: '/teams',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'dashboard',
      displayName: 'Ops Console',
      meta: {
        icon: 'dashboard',
        allowedRoles: ['team_manager'],
      },
      children: [
        {
          name: 'performance',
          displayName: 'Performance Dashboard',
          meta: {
            icon: 'analytics',
            allowedRoles: ['team_manager'],
          },
        },
        {
          name: 'analytics',
          displayName: 'Analytics',
          meta: {
            icon: 'assessment',
            allowedRoles: ['team_manager'],
          },
        },
        {
          name: 'ev-dashboard',
          displayName: 'EV Dashboard',
          meta: {
            icon: 'ev_station',
            allowedRoles: ['team_manager'],
          },
        },
      ],
    },
    {
      name: 'drivers',
      displayName: 'Driver Management',
      meta: {
        icon: 'moped',
        allowedRoles: ['team_manager'],
      },
      children: [
        {
          name: 'drivers',
          displayName: 'Driver Funnel',
          meta: {
            icon: 'moped',
            allowedRoles: ['team_manager'],
          },
        },
        {
          name: 'our-drivers',
          displayName: 'Our Drivers',
          meta: {
            icon: 'person',
            allowedRoles: ['team_manager'],
          },
        },
        {
          name: 'trips',
          displayName: 'Trip Analytics',
          meta: {
            icon: 'route',
            allowedRoles: ['team_manager'],
          },
        },
        {
          name: 'operators',
          displayName: 'Ops Staff',
          meta: {
            icon: 'support_agent',
            allowedRoles: ['team_manager'],
          },
        },
      ],
    },
    {
      name: 'vehicles',
      displayName: 'Fleet Management',
      meta: {
        icon: 'commute',
        allowedRoles: ['team_manager'],
      },
      children: [
        {
          name: 'vehicles',
          displayName: 'Vehicle Fleet',
          meta: {
            icon: 'commute',
            allowedRoles: ['team_manager'],
          },
        },
        {
          name: 'our-vehicles',
          displayName: 'Our Vehicles',
          meta: {
            icon: 'directions_car',
            allowedRoles: ['team_manager'],
          },
        },
        {
          name: 'bikes',
          displayName: 'Bikes',
          meta: {
            icon: 'two_wheeler',
            allowedRoles: ['team_manager'],
          },
        },
        {
          name: 'maintenance',
          displayName: 'Charging Stations',
          meta: {
            icon: 'ev_station',
            allowedRoles: ['team_manager'],
          },
        },
        {
          name: 'maintenance-items',
          displayName: 'Station Uptime',
          meta: {
            icon: 'build',
            allowedRoles: ['team_manager'],
          },
        },
        {
          name: 'maintenance-workshops',
          displayName: 'Fault Management',
          meta: {
            icon: 'report_problem',
            allowedRoles: ['team_manager'],
          },
        },
      ],
    },
    {
      name: 'tickets',
      displayName: 'Performance Tracking',
      meta: {
        icon: 'assignment',
        allowedRoles: ['team_manager'],
      },
      children: [
        {
          name: 'tickets',
          displayName: 'Ticket Management',
          meta: {
            icon: 'assignment',
            allowedRoles: ['team_manager'],
          },
        },
        {
          name: 'issues',
          displayName: 'Task Performance',
          meta: {
            icon: 'report_problem',
            allowedRoles: ['team_manager'],
          },
        },
        {
          name: 'teams',
          displayName: 'Team Performance',
          meta: {
            icon: 'group',
            allowedRoles: ['team_manager'],
          },
        },
      ],
    },
    {
      name: 'reports',
      displayName: 'Reports & Analytics',
      meta: {
        icon: 'assessment',
        allowedRoles: ['team_manager'],
      },
      children: [
        {
          name: 'reports',
          displayName: 'SLA Reports',
          meta: {
            icon: 'assessment',
            allowedRoles: ['team_manager'],
          },
        },
        {
          name: 'analytics',
          displayName: 'Performance Analytics',
          meta: {
            icon: 'analytics',
            allowedRoles: ['team_manager'],
          },
        },
        {
          name: 'scorecard',
          displayName: 'Performance Scorecard',
          meta: {
            icon: 'scorecard',
            allowedRoles: ['team_manager'],
          },
        },
        {
          name: 'odometer-reports',
          displayName: 'Odometer Reports',
          meta: {
            icon: 'speed',
            allowedRoles: ['team_manager'],
          },
        },
        {
          name: 'charging-reports',
          displayName: 'Charging Reports',
          meta: {
            icon: 'battery_charging_full',
            allowedRoles: ['team_manager'],
          },
        },
      ],
    },
    {
      name: 'preferences',
      displayName: 'Profile',
      meta: {
        icon: 'manage_accounts',
        allowedRoles: ['team_manager'],
      },
    },
  ],
}

export default sidebarRoutes
